
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export interface RejectDialogProps {
  open: boolean;
  onClose: () => void;
  onReject: (comments: string) => void;
}

export const RejectDialog = ({ open, onClose, onReject }: RejectDialogProps) => {
  const [comments, setComments] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onReject(comments);
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px] rounded-2xl">
        <DialogHeader>
          <DialogTitle className="text-center text-xl">Reject Report</DialogTitle>
          <DialogDescription className="text-center">
            Provide a reason for rejecting this expense report.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit}>
          <div className="grid gap-4 py-4">
            <div className="grid gap-2">
              <Label htmlFor="comments">
                Rejection Comments
              </Label>
              <Textarea
                id="comments"
                value={comments}
                onChange={(e) => setComments(e.target.value)}
                placeholder="Please explain why this report is being rejected"
                className="min-h-[100px] rounded-xl"
                required
              />
            </div>
          </div>
          <DialogFooter className="flex-col space-y-2 sm:space-y-0">
            <Button type="submit" variant="destructive" className="w-full sm:w-auto rounded-xl">
              Reject Report
            </Button>
            <Button type="button" variant="outline" onClick={onClose} className="w-full sm:w-auto rounded-xl">
              Cancel
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
